import style from './style.module.scss';
import { Alert } from 'antd';

type InfoBannerProps = {
    message: string;
    description: string;
    type?: 'success' | 'info' | 'warning' | 'error';
    showIcon?: boolean;
};

export const InfoBanner = ({
    message,
    description,
    type = 'info',
    showIcon = true,
}: InfoBannerProps) => {
    return (
        <Alert
            message={
                <span className={style.info_banner_message}>{message}</span>
            }
            description={
                description && (
                    <span className={style.info_banner_description}>
                        {description}
                    </span>
                )
            }
            type={type}
            showIcon={showIcon}
        />
    );
};
